import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { DataGridComponent } from './data-grid.component';
import { GridActionBarComponent } from './grid-action-bar/grid-action-bar.component';
import { GridSectionHeaderComponent } from './grid-section-header/grid-section-header.component';

@NgModule({
  declarations: [
    DataGridComponent,
    GridSectionHeaderComponent,
    GridActionBarComponent
  ],
  imports: [CommonModule, AgGridModule.withComponents([])],
  exports: [
    DataGridComponent,
    GridSectionHeaderComponent,
    GridActionBarComponent
  ]
})
export class DataGridModule {}
